import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { api } from "../../api";
import DataTable from "react-data-table-component";
import { customStyles } from "../../styles/dataTableStyles";


const ResellerType = ({ addAccess }) => {
  const token = useSelector((state) => state.auth.token);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  // eslint-disable-next-line
  const [listingReset, setListingReset] = useState(false);
  const [supportList, setSupportList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const fetchResellerTypes = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.resellerType.getResellerTypeList(
        { pageNo, pageSize, sort: "asc", sortBy: "createdAt", searchKey},
        token
      );
      if (response.data) {
        setSupportList(response.data);
  
        setTotalRows(2);
      } else {
        setSupportList([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Error fetching customer support users", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      if (search) setPage(1);
      fetchResellerTypes(page, search, pageSize);
    }, 500);
    return () => clearTimeout(delaySearch);
  }, [page, search, pageSize, listingReset, fetchResellerTypes]);



  const columns = [
    { name: "ID", selector: row => row.id, sortable: true, width: "120px" },
    { name: "Name", selector: row => row.name, sortable: true, width: "300px" },
    { name: "Currency", selector: row => row.currency, width: "300px" },
 
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">RESLLER REGION</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

        
        </div>
      </div>
      <DataTable
        columns={columns}
        data={supportList}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        highlightOnHover
        customStyles={customStyles}
        responsive
        wrap
      />
    </div>
  );
};

export default ResellerType;
